import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function UnaziendaItaliana() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef1,
    isVisible: contentVisible1
  } = useRevealOnScroll();
  const {
    ref: imageRef1,
    isVisible: imageVisible1
  } = useRevealOnScroll();
  const {
    ref: contentRef2,
    isVisible: contentVisible2
  } = useRevealOnScroll();
  const {
    ref: imageRef2,
    isVisible: imageVisible2
  } = useRevealOnScroll();
  const {
    ref: contentRef3,
    isVisible: contentVisible3
  } = useRevealOnScroll();
  return <section id="unazienda-italiana" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8">
        {}
        <div ref={headerRef} className={cn("mb-16 text-center transition-all duration-1000 ease-out transform", headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#333333] tracking-tight">
            Chi Siamo
          </h1>
        </div>

        {}
        <div className="max-w-3xl mx-auto">
          
          {}
          <div ref={contentRef1} className={cn("prose prose-lg max-w-none text-[#333333] leading-[1.8] transition-all duration-1000 delay-200 ease-out transform", contentVisible1 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <p className="text-lg md:text-xl font-light">
              <span className="font-semibold text-primary">Un’azienda tutta italiana.</span> Siamo una realtà giovane e dinamica, con l’obiettivo di offrire un’esperienza unica nel settore dei serramenti. Al centro del nostro lavoro ci sono la cura del cliente, l’eccellenza dei prodotti e la volontà di fornire un servizio completo e altamente professionale.
            </p>
          </div>

          {}
          <div ref={imageRef1} className={cn("my-12 md:my-16 transition-all duration-1000 delay-300 ease-out transform", imageVisible1 ? "opacity-100 scale-100" : "opacity-0 scale-95")}>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-muted">
              <AspectRatio ratio={16 / 9}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/lora_serramenti_workshop_team.png" alt="Il team di Lora Serramenti al lavoro nel laboratorio" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" />
              </AspectRatio>
            </div>
            <p className="mt-3 text-sm text-muted-foreground text-center italic">
              Artigianalità e precisione in ogni dettaglio.
            </p>
          </div>

          {}
          <div ref={contentRef2} className={cn("prose prose-lg max-w-none text-[#333333] leading-[1.8] transition-all duration-1000 delay-200 ease-out transform", contentVisible2 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <p className="text-lg md:text-xl font-light">
              Garantiamo soluzioni personalizzate che uniscono design, qualità e innovazione. Per questo motivo le nostre porte e i nostri serramenti sono veri e propri elementi d’arredo che danno vita a spazi accoglienti e funzionali. Crediamo che ogni casa meriti di essere valorizzata con prodotti che durano nel tempo.
            </p>
          </div>

          {}
          <div ref={imageRef2} className={cn("my-12 md:my-16 transition-all duration-1000 delay-300 ease-out transform", imageVisible2 ? "opacity-100 scale-100" : "opacity-0 scale-95")}>
            <div className="rounded-2xl overflow-hidden shadow-lg bg-muted">
              <AspectRatio ratio={21 / 9}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1561763/img/lora_serramenti_craftsmanship_detail.png" alt="Dettaglio di un serramento moderno Lora Serramenti" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700 ease-in-out" />
              </AspectRatio>
            </div>
          </div>

          {}
          <div ref={contentRef3} className={cn("prose prose-lg max-w-none text-[#333333] leading-[1.8] transition-all duration-1000 delay-200 ease-out transform", contentVisible3 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
            <p className="text-lg md:text-xl font-light">
              La famiglia Vernè, con oltre <span className="text-primary font-bold text-xl md:text-2xl">50 anni di storia</span> dedicata alla progettazione e alla realizzazione di serramenti, porte, scale e mobili su misura, è un nome di riferimento nel settore. Una tradizione che si rinnova ogni giorno per offrire il meglio del Made in Italy.
            </p>
          </div>

        </div>
      </div>
    </section>;
}